module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('side-bar', {
    attrs: {
      "problems": _vm.problems
    }
  }), _vm._v(" "), _c('post', {
    attrs: {
      "content": _vm.content,
      "question": _vm.question,
      "title": _vm.title,
      "post": _vm.post
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.content == ''),
      expression: "content == ''"
    }],
    staticClass: "posts tac loading-container"
  }, [_c('pulse-out-loader', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "height": 100,
      "width": 10,
      "margin": 5
    }
  })], 1), _vm._v(" "), (_vm.enableDuoShuo && _vm.duoShuoRunning && _vm.content != '') ? _c('duo-shuo', {
    attrs: {
      "articleId": _vm.duoShuoArticleId,
      "articleTitle": _vm.duoShuoArticleTitle,
      "postId": _vm.postId
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-9a15cff4!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/Source.vue
// module id = 80
// module chunks = 2